import { createAction, props } from '@ngrx/store';
import { InvoiceQuery } from '../../models/invoice-query';
import { Invoice } from '../../models/invoice';

export const invoiceTableRequest = createAction(
    '[Invoice Table] Load Request'
);

export const invoiceTableSuccess = createAction(
    '[Invoice Table] Load Response',
    props<{ totalCount: number, page: Invoice[] }>()
);

export const invoiceTableFailure = createAction(
    '[Invoice Table] Load Failure'
);

export const invoiceTableChangePage = createAction(
    '[Invoice Table] Change Page',
    props<{ pageNumber: number, itemsPerPage: number }>()
);

export const invoiceTableChangeQuery = createAction(
    '[Invoice Table] Change Filter',
    props<{ query: InvoiceQuery }>()
);

export const invoiceTableSort = createAction(
    '[Invoice Table] Change Sort Column',
    props<{ id: string, descending: boolean }>()
);

export const invoiceTableSetSelection = createAction(
    '[Invoice Table] Set Selection',
    props<{ selection: string[] }>()
);

export const invoiceTableMasterToggle = createAction(
    '[Invoice Table] Master Selection Toggle'
);

export const invoiceTableToggle = createAction(
    '[Invoice Table] Toggle Selection',
    props<{ id: string }>()
);

export const invoiceTableAddAssist = createAction(
    '[Invoice Table] Add Filter Assist',
    props<{ id: string, parameter: any }>()
);

export const invoiceTableRemoveAssist = createAction(
    '[Invoice Table] Remove Filter Assist',
    props<{ id: string }>()
);


